import { useMemo } from 'react';
import cm from 'classnames';

import { PanZoomRotateConfig } from 'services/clip.service';
import { useAppSelector } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { PanZoomIndex, selectClipData } from 'components/app/editor/_mediator/editor.slice';
import { usePanZoomCb } from 'components/app/editor/pan-zoom/_mediator/use-pan-zoom-cb';
import { useSbPanZoomSeek } from 'components/app/storyboard/sb-pan-zoom/use-sb-pan-zoom-seek';

import { ReactComponent as KeyFrameIcon } from 'assets/ui/keyframe.svg';
import styles from '../_editor-config.module.scss';

export const ConfigPanZoom = () => {
  const clipData = useAppSelector(selectClipData)?.config.panZoomRotate ?? [null, null];
  return (
    <div>
      <div className={styles.ConfigPanZoom}>
        <KeyFrame index={0} data={clipData} />
        <div
          className={cm(styles.ConfigPanZoom__line, {
            [styles['ConfigPanZoom--configured']]: clipData[0] && clipData[1],
          })}
        />
        <KeyFrame index={1} data={clipData} />
      </div>
    </div>
  );
};

/* C O M P O N E N T S */

interface KeyFrameProps {
  index: PanZoomIndex;
  data: PanZoomRotateConfig;
}

const KeyFrame = ({ index, data }: KeyFrameProps) => {
  const { path } = useLocation();
  const { handleReset } = usePanZoomCb();
  const keyFrameIndex = useAppSelector((state) => state.editor.panZoomKeyFrameIndex);
  const panZoomControl = useAppSelector((state) => state.sb.panZoomControl);
  const sbSeekToKey = useSbPanZoomSeek();

  const isSelected = useMemo(() => {
    if (path !== Path.storyboard) return keyFrameIndex === index;
    return panZoomControl && keyFrameIndex === index;
  }, [path, panZoomControl, keyFrameIndex]);

  return (
    <div
      className={cm(styles.ConfigPanZoom__keyFrame, {
        [styles['ConfigPanZoom--selected']]: isSelected,
        [styles['ConfigPanZoom--configured']]: data[index],
      })}
      onClick={() => sbSeekToKey(index)}
      onDoubleClick={handleReset}
    >
      <KeyFrameIcon />
    </div>
  );
};
